<template>
  <div>
    <v-parallax
      dark
      :height="banner_height"
      src="../../public/banniereBDSR.jpg"
    >
      <v-row align="center" justify="center" class="backgroundfilter">
        <v-col lg="11" class="my-4">
          <v-row class="my-4 py-4 mx-4 px-4">
            <v-col class="my-4 py-4" cols="12">
              <h1
                class="text-h3 text-md-h2 white--text font-weight-medium mb-3"
              >
                {{ $t("home.welcome") }}
              </h1>

              <div
                class="text-subtitle-2 text-md-h6 font-weight-light white--text"
              >
                {{ $t("home.info2") }}
              </div>
              <h2 class="text-h6 text-md-h5 font-weight-light white--text">
                <span class="mr-2">
                  {{ $t("home.info1") }}
                  <v-icon
                    x-large
                    color="white"
                    class="pb-2"
                    @click="navigate('/search')"
                  >
                    mdi-magnify
                  </v-icon>
                </span>
              </h2>
              <br />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-parallax>
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" lg="11">
          <v-row>
            <v-col class="my-4" cols="12" lg="8" md="7">
              <h1 class="text-h5 text-md-h4 mb-3 ml-4 pl-4">
                <v-icon x-large color="primary" class="pb-2">
                  mdi-newspaper
                </v-icon>
                {{ $t("home.news") }}
              </h1>
              <v-divider></v-divider>
              <news-cards :news="news"></news-cards>
            </v-col>
            <v-col class="my-4 px-4" cols="12" lg="4" md="5">
              <v-row>
                <v-col class="mx-4">
                  <h1 class="text-h5 text-md-h4 mb-3 ml-2">
                    <v-icon x-large color="primary" class="pb-2">
                      mdi-chart-bar
                    </v-icon>
                    {{ $t("home.changes") }}
                  </h1>
                  <v-divider></v-divider>
                  <changes-cards></changes-cards>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="my-4" cols="12"></v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
.backgroundfilter {
  background: linear-gradient(
    to right top,
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.1)
  );
}
</style>

<script>
import NewsCards from "./NewsCards.vue";
import ChangesCards from "./ChangesCards.vue";

export default {
  name: "HelloWorld",

  components: {
    NewsCards,
    ChangesCards,
  },

  data: () => ({
    news: [],
  }),
  beforeMount() {
    this.getNews();
  },
  computed: {
    banner_height() {
      let height = 250;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          height = 250;
          break;
        case "sm":
          height = 200;
          break;
        case "md":
          height = 200;
          break;
        case "lg":
          height = 250;
          break;
        case "xl":
          height = 300;
          break;
      }
      return height;
    },
  },
  methods: {
    async getNews() {
      var request = { method: "GET", url: "/news" };
      try {
        var response = await this.axios(request);
        this.news = response.data;
        response = response.data;
      } catch (err) {
        console.log(err);
      }
    },
    navigate(link) {
      this.$router.push(link);
    },
  },
};
</script>
